Object.defineProperty(exports, '__esModule', { value: true });

var logWarning = function (currency) {
    if (process.env.NODE_ENV !== 'development') {
        return;
    }
    if (currency && currency === 'RUR') {
        // eslint-disable-next-line no-console
        console.warn("@alfalab/core-components/amount: currency='".concat(currency, "' - @deprecated. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 'RUB'"));
    }
};

exports.logWarning = logWarning;
